import {
	GetSensorHistoryParams,
	GetSensorHistoryResponse,
	NewSensorDataPointsParams as NewSensorDataPoints,
} from '@Types/editSensorData.types';
import { GetSensorsResponse, SensorParams } from '@Types/sensors.types';

import { Configuration } from '@Types/configuration.types';
import { ConfigurationParams } from '@Types/configurations.types';
import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import {
	FilterVirtualSensor,
	SensorsHealthStatus,
	SensorsUptime,
	VirtualSensor,
} from '@Types/sensor.types';
import {
	SensorsLatestDataRequest,
	SensorsUptimeDataRequest,
} from '@Types/edgeAnalytics.types';

export const getSensor = createAction<SensorParams>(
	addNamespace('sensors/getSensor'),
);
export const getSensorResolved = createAction<GetSensorsResponse>(
	addNamespace('sensors/getSensor/resolved'),
);
export const getSensorRejected = createAction(
	addNamespace('sensors/getSensor/rejected'),
);
export const getSensorHistory = createAction<GetSensorHistoryParams>(
	addNamespace('sensors/getSensorHistory'),
);
export const getSensorHistoryResolved = createAction<GetSensorHistoryResponse>(
	addNamespace('sensors/getSensorHistory/resolved'),
);
export const getSensorHistoryRejected = createAction(
	addNamespace('sensors/getSensorHistory/rejected'),
);

export const editSensorDataPoints = createAction<NewSensorDataPoints[]>(
	addNamespace('sensors/editSensorDataPoints'),
);

export const editSensorDataPointsResolved = createAction<NewSensorDataPoints[]>(
	addNamespace('sensors/editSensorDataPoints/resolved'),
);

export const editSensorDataPointsRejected = createAction(
	addNamespace('sensors/editSensorDataPoints/rejected'),
);
export const getSensorIdsMap = createAction<ConfigurationParams>(
	addNamespace('sensors/sensorIdsMap/get'),
);
export const clearSensorIdsMap = createAction(
	addNamespace('sensors/sensorIdsMap/clear'),
);
export const getSensorIdsMapResolved = createAction<{
	[key: string]: Configuration;
}>(addNamespace('sensors/sensorIdsMap/get/resolved'));
export const getSensorIdsMapRejected = createAction(
	addNamespace('sensors/sensorIdsMap/get/rejected'),
);

export const getVirtualSensors = createAction<FilterVirtualSensor>(
	addNamespace('sensors/virtualSensors/get'),
);
export const getVirtualSensorsResolved = createAction<VirtualSensor[]>(
	addNamespace('sensors/virtualSensors/get/resolved'),
);
export const getVirtualSensorsRejected = createAction(
	addNamespace('sensors/virtualSensors/get/rejected'),
);

export const getVirtualSensorsCount = createAction(
	addNamespace('sensors/virtualSensorsCount/get'),
);
export const getVirtualSensorsCountResolved = createAction<number>(
	addNamespace('sensors/virtualSensorsCount/get/resolved'),
);
export const getVirtualSensorsCountRejected = createAction(
	addNamespace('sensors/virtualSensorsCount/get/rejected'),
);

export const getPhysicalSensorsCount = createAction(
	addNamespace('sensors/physicalSensorsCount/get'),
);
export const getPhysicalSensorsCountResolved = createAction<number>(
	addNamespace('sensors/physicalSensorsCount/get/resolved'),
);
export const getPhysicalSensorsCountRejected = createAction(
	addNamespace('sensors/physicalSensorsCount/get/rejected'),
);

export const getSensorById = createAction<string>(
	addNamespace('sensors/getSensorById'),
);
export const getSensorByIdResolved = createAction<GetSensorsResponse>(
	addNamespace('sensors/getSensorById/resolved'),
);
export const getSensorByIdRejected = createAction(
	addNamespace('sensors/getSensorById/rejected'),
);

export const getSensorsLatestData = createAction<SensorsLatestDataRequest[]>(
	addNamespace('sensorsEdgeAnalytics/getSensorsLatestData'),
);
export const getSensorsLatestDataResolved = createAction<SensorsUptime>(
	addNamespace('sensorsEdgeAnalytics/getSensorsLatestData/resolved'),
);
export const getSensorsLatestDataRejected = createAction(
	addNamespace('sensorsEdgeAnalytics/getSensorsLatestData/rejected'),
);

export const getSensorsHealthStatus = createAction<SensorsUptimeDataRequest[]>(
	addNamespace('sensorsEdgeAnalytics/getSensorsHealthStatus'),
);
export const getSensorsHealthStatusResolved = createAction<SensorsHealthStatus>(
	addNamespace('sensorsEdgeAnalytics/getSensorsHealthStatus/resolved'),
);
export const getSensorsHealthStatusRejected = createAction(
	addNamespace('sensorsEdgeAnalytics/getSensorsHealthStatus/rejected'),
);

/**
 * @ deprecated
 */
export const getSensorsHealthStatusLegacy = createAction<string[]>(
	addNamespace('sensorsEdgeAnalytics/getSensorsHealthStatusLegacy'),
);

/**
 * @ deprecated
 */
export const getSensorsHealthStatusResolvedLegacy =
	createAction<SensorsHealthStatus>(
		addNamespace(
			'sensorsEdgeAnalytics/getSensorsHealthStatusLegacy/resolved',
		),
	);

/**
 * @ deprecated
 */
export const getSensorsHealthStatusRejectedLegacy = createAction(
	addNamespace('sensorsEdgeAnalytics/getSensorsHealthStatusLegacy/rejected'),
);
